module.exports = __webpack_public_path__ + "img/60_12.a5e74b4f.png";